import { t } from '@hefe/i18n';
import { LocationClosure, RequestBasePostLocationClosure } from '@hefe/models';
import { GymsSlice, LocationClosuresApi, ModalsSlice } from '@hefe/store';
import { Alert } from 'antd';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface AddEditGymClosureFormProps {
  closure?: LocationClosure;
}

export default function AddEditGymClosureForm(
  props: AddEditGymClosureFormProps
) {
  const { closure } = props;

  const dispatch = useAppDispatch();
  const [saveLocationClosure, { isLoading }] =
    LocationClosuresApi.useCreateOrUpdateLocationClosureMutation();

  const modalState = useSelector(ModalsSlice.modalsState);
  const gyms = useSelector(GymsSlice.gymsSelectSelector);

  const onSubmit = (values: any, resetForm: any) => {
    const closeModal = ModalsSlice.modalsActions.closeModal;
    const setModalLoading = ModalsSlice.modalsActions.setModalLoading;

    const request: RequestBasePostLocationClosure = {
      ...(closure ? { id: closure.id } : {}),
      closed_from: (values.dates[0] as dayjs.Dayjs).format('YYYY-MM-DD'),
      closed_until: (values.dates[1] as dayjs.Dayjs).format('YYYY-MM-DD'),
      reason: values.reason,
      gym_ids: values.gym_ids,
    };

    dispatch(setModalLoading(true));
    saveLocationClosure(request)
      .unwrap()
      .then(() => {
        //resetForm();
        dispatch(closeModal());
      })
      .finally(() => {
        dispatch(setModalLoading(false));
      });
  };

  return (
    <>
      <CustomForm
        key={`add-edit-gym-closure-form-${closure ? closure.id : 'new'}`}
        formId={`add-edit-gym-closure-form-${closure ? closure.id : 'new'}`}
        fields={[
          {
            name: 'reason',
            label: t('gyms.closures.reason'),
            type: 'text',
            initalValue: closure?.reason,
            rules: [
              {
                required: true,
                message: t('form_errors.value'),
              },
            ],
          },
          {
            name: 'dates',
            label: t('from') + ' - ' + t('till'),
            type: 'daterange',
            initalValue: [
              dayjs(closure?.closed_from),
              dayjs(closure?.closed_until),
            ],
            rules: [
              {
                required: true,
                message: t('form_errors.date_range'),
              },
            ],
          },
          {
            name: 'gym_ids',
            label: t('gyms.plural'),
            type: 'select',
            initalValue: closure?.gyms?.map((gym) => gym.id),
            selectOptions: gyms,
            multiSelect: true,
            rules: [],
          },
        ]}
        loading={modalState.modal.loading || isLoading}
        onSubmit={onSubmit}
      />
      <Alert message={t('gyms.closures.practice_sync_info')} type="warning" />
    </>
  );
}
